export const Dropdown = () => {
  const $dropdowns = $('.js-dropdown')

  $dropdowns.each(function () {
    const $dropdown = $(this)
    const $button = $dropdown.find('.js-dropdown__button')
    const $list = $dropdown.find('.js-dropdown__list')

    $button.on('click', function (e) {
      e.preventDefault();
      $list.toggleClass('c-dropdown__list--open');
    });

    $(document).on('click', function (e) {
      if (!$(e.target).closest($dropdown).length) {
        $list.removeClass('c-dropdown__list--open');
      }
    });
  })

}
